import { AssetPurchaseOrdersService } from '~/services/modules/assets/orders/asset-purchase-orders.service';
import { AssetCheckOutTransactionsService } from '~/services/modules/assets/transactions/checkOutTransaction';
import { AssetCheckInTransactionsService } from '~/services/modules/assets/transactions/checkInTransaction';
import { AssetMoveTransactionsService } from '~/services/modules/assets/transactions/moveTransaction';
import { AssetDisposeTransactionsService } from '~/services/modules/assets/transactions/disposeTransaction';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { PopupRef } from '@progress/kendo-angular-popup';
import { groupBy } from '@progress/kendo-data-query';
import { formComponentMapOptions } from '~/front-models/form-component-map';
import { ComponentBase } from '~/infrastructure/component-base';
import { UserSummary } from '~/models/administration/user';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { PageState } from '~/shared/enums/stock-files.enum';
import { LayoutManagerService } from '../../layout/layout-manager';
import { LayoutComponent } from '../../layout/layout.component';
import { HistorySettingsService } from '~/services/administration.ts/history-settings';
import { GridLayoutManagerService } from './grid-layout-manager';
import { GridLayoutComponent } from './layout.component';
import { BehaviorSubject } from 'rxjs';
import { EntityStatus } from '~/shared/enums/itemsTypes';
import { IAssetReservationDto } from '~/models/modules/Asset/Transactions/Reservation/IAssetReservationDto';
import { IAssetReservationDetailsDto } from '~/models/modules/Asset/Transactions/Reservation/assetReservationDetailsDto';
import { IAssetDto } from '~/models/modules/Asset/asset';

@Component({
    selector: 'asap-grid-layout-header',
    templateUrl: './header.html',
    styleUrls: ['./header.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GridLayoutHeaderComponent<T> extends ComponentBase implements OnInit {

  // public data: Array<any> = [
  //   { name: "Pork", category: "Food", subcategory: "Stock item" },
  //   { name: "Pepper", category: "Food", subcategory: "General" },
  //   { name: "Beef", category: "Food", subcategory: "Stock item" },
  // ];
  // public groupedData: GroupResult[] = groupBy(this.data, [
  //   { field: "subcategory" },
  // ]);
  _groupedData: any[];
  _searchControl = new FormControl();
  _gridColumns: GridFieldSummary[];
  _selectedColumns: any[] = [];
  _theme: string;
  _groupingEnabled: boolean;
  @Input() _inActiveMode: boolean;
  @Input() _isClosed: boolean;
  @Input() _assetPurchaseOrderStatusValue: number = null;
  @Input() _stockPurchaseOrderStatusValue: number = null;
  @Input() _stockSalesOrderStatusValue: number = null;
  @Input() _siteTransferStatusValue: any = null;
  @Input() assetReservationItemTypeValue: number = null;
  @Input() isAssetReservation: number = null;
  @Input() performMaintenanceItemTypeValue: any = null;
  @Input() isPerformMaintenance: boolean = false;
  @Input() disposeAuthorizationStatusValue: any = null;
  @Input() overridePage: string = '';
  @Input() isHistoryPage: boolean = false;
  @Input() _historyFilterValue: any = null;
  historyFilterOptions: any[] = [
    { text: 'Last Day', value: 'LastDay' },
    { text: 'Last Month', value: 'LastMonth' },
    { text: 'Last Six Months', value: 'LastSixMonths' },
    { text: 'All', value: 'All' },
  ];
  historyFilterValue: any = { text: 'Last Month', value: 'LastMonth' };

  _isOs: boolean;
  _columnChooserPopup: PopupRef;
  _showGraph: boolean;

  showTextBox = false;


  listItems: Array<string> = ['Move', 'Check Out', 'Check In', 'Dispose', 'Issue', 'Deactivate', 'Map', 'Receive'];
  assetsModules: string[] = ['departments', 'statuses', 'conditions', 'assetTypes', 'Models', 'assets', 'fundingSources', 'asset-purchaseOrders', 'asset-inventory']

  allowCustom = true;

  applesBasket$: BehaviorSubject<number>;
  grideditcolumn: BehaviorSubject<GridFieldSummary[]>;
  _gridColumnSubjects3: { [page: string]: BehaviorSubject<GridFieldSummary[]> } = {};
  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  okCloseSubscription: any = null;
  _editColumnsActive = false;
  @Input() _currentUser: UserSummary;
  @Input() page: string;
  @Input() title: string;
  @Input() importEnable: boolean;
  @Input() searchEnable: boolean;
  @Input() deletedEnabled: boolean;
  @Input() addNewFormEnabled: boolean;
  @Input() graphEnabled: boolean;
  @Input() exportExcelEnable: boolean;
  @Input() exportPDFEnable: boolean;
  @Input() exportCSVEnabled: boolean;
  @Input() exportWordEnabled: boolean;
  @Input() groupingEnabled: boolean;
  @Input() selectedItems: any[];
  @Input() canDeactivate: boolean;
  @Input() canActivate: boolean;
  @Input() canReceive: boolean;
  @Input() canMove: boolean;
  @Input() canDispose: boolean;
  @Input() canIssue: boolean;
  @Input() canReactivate: boolean;
  @Input() canApprove: boolean = false;
  @Input() canReject: boolean = false;
  @Input() canCheckOut: boolean = false;
  @Input() canCheckIn: boolean = false;
  @Input() editColumnsEnabled: boolean;
  @Input() reloadDataEnabled: boolean;
  @Input() entityName: string;
  @Output() onSearch: EventEmitter<string> = new EventEmitter();
  @Output() refreshButtonClicked: EventEmitter<string> = new EventEmitter();
  @Output() viewActiveInActiveClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() batchActionClicked: EventEmitter<string> = new EventEmitter<string>();
  //_isTransactionFire: BehaviorSubject<any>;

  @ViewChild('search', { static: false }) searchInput: ElementRef;
  @ViewChild('kendo_batchactions') kendoBatchActions: ComboBoxComponent;

  @ViewChild('titleTextBox') titleTextBox: ElementRef;
  _stockLicense: any;
  _assetLicense: any;
  _generalLicense: any;
  get maxColumns(): number {
    return this._generalLicense?.extendedInventoryColumns ? 15 : 12;
  }
  SiteFields = ['site.code', 'site.id', 'site.name',
    'site.description', 'sitesSiteCode', 'sitesSiteName',
    'site.city', 'site.zip', 'site.country', 'site.address1', 'site.address2', 'site.state',
    'sitesShipToState', 'sitesShipToCountry', 'sitesShipToZip', 'sitesShipToCity', 'sitesShipToAddress1', 'sitesShipToAddress2'
  ]
  //   SiteFields = ['site.code','site.id','site.name',
  //   'site.description','sitesSiteCode','sitesSiteName',
  //   'sitesShipToState,sitesShipToCountry','sitesShipToZip','sitesShipToCity','sitesShipToAddress1','sitesShipToAddress2',
  // 'siteId','site.city','site.zip', 'site.country', 'site.address1', 'site.address2']
  receivebehavior: BehaviorSubject<any>;
  //#region Asset Purchase Orders Properties

  assetPurchaseOrdersStatus: any = [
    { id: '1', code: 'Open Purchase Orders' },
    { id: '2', code: 'Closed Purchase Orders' },
    { id: '5', code: 'Rejected' },
    { id: '0', code: 'All Purchase Orders' },
    { id: '3', code: 'Need Approval' },
  ];
  assetPurchaseOrdersStatusFiltered: any = [
    { id: '1', code: 'Open Purchase Orders' },
    { id: '2', code: 'Closed Purchase Orders' },
    { id: '5', code: 'Rejected' },
    { id: '0', code: 'All Purchase Orders' },
    { id: '3', code: 'Need Approval' },
  ];

  assetPurchaseOrdersStatusValue: any;// = this.assetPurchaseOrdersStatusFiltered[0];

  stockPurchaseOrdersStatus: any = [
    { id: '1', code: 'Open Purchase Orders' },
    { id: '2', code: 'Closed Purchase Orders' },
    { id: '5', code: 'Rejected' },
    { id: '0', code: 'All Purchase Orders' },
    { id: '3', code: 'Need Approval' },
  ];
  stockPurchaseOrdersStatusFiltered: any = [
    { id: '1', code: 'Open Purchase Orders' },
    { id: '2', code: 'Closed Purchase Orders' },
    { id: '5', code: 'Rejected' },
    { id: '0', code: 'All Purchase Orders' },
    { id: '3', code: 'Need Approval' },
  ];

  stockPurchaseOrdersStatusValue: any;

  stockSalesOrdersStatus: any = [
    { id: '1', code: 'Open Sales Orders' },
    { id: '2', code: 'Closed Sales Orders' },
    { id: '5', code: 'Rejected Sales Orders' },
    { id: '0', code: 'All Sales Orders' },
    { id: '3', code: 'Need Approval' },
  ];
  stockSalesOrdersStatusFiltered: any = [
    { id: '1', code: 'Open Sales Orders' },
    { id: '2', code: 'Closed Sales Orders' },
    { id: '5', code: 'Rejected Sales Orders' },
    { id: '0', code: 'All Sales Orders' },
    { id: '3', code: 'Need Approval' },
  ];

  stockSalesOrdersStatusValue: any;

  siteTransfersStatus: any = [
    { id: '1', code: 'Open Site Transfers' },
    { id: '2', code: 'In-Transit Site Transfers' },
    { id: '3', code: 'Closed Site Transfers' },
    { id: '4', code: 'Rejected Site Transfers' },
    { id: '5', code: 'Approval Pending Request' },
    { id: '0', code: 'All Site Transfers' },
  ];
  siteTransfersStatusFiltered: any = [
    { id: '1', code: 'Open Site Transfers' },
    { id: '2', code: 'In-Transit Site Transfers' },
    { id: '3', code: 'Closed Site Transfers' },
    { id: '4', code: 'Rejected Site Transfers' },
    { id: '5', code: 'Approval Pending Request' },
    { id: '0', code: 'All Site Transfers' },
  ];
  siteTransfersStatusValue: any;

  assetReservationFiltered: any = [
    { id: '1', code: 'All' },
    { id: '2', code: 'Available' },
    { id: '3', code: 'Reserved' },
    { id: '4', code: 'Reservation List' },
  ];

  assetReservation: any = [
    { id: '1', code: 'All' },
    { id: '2', code: 'Available' },
    { id: '3', code: 'Reserved' },
    { id: '4', code: 'Reservation List' },
  ];
  assetReservationValue: any;

  @ViewChild('kendo_assetpurchaseOrdersStatus') kendoAssetPurchaseOrdersStatus: ComboBoxComponent;
  @ViewChild('kendo_stockpurchaseOrdersStatus') kendoStockPurchaseOrdersStatus: ComboBoxComponent;
  @ViewChild('kendo_stockSalesOrdersStatus') kendoStockSalesOrdersStatus: ComboBoxComponent;
  @ViewChild('kendo_siteTransfersStatus') kendoSiteTransfersStatus: ComboBoxComponent;
  @ViewChild('kendo_ReservationStatus') kendoAssetReservation: ComboBoxComponent;
  @ViewChild('kendo_DisposeAuthorization') kendoDisposeAuthorization: ComboBoxComponent;
  @ViewChild('kendo_performMaintenance') kendoPerformMaintenance: ComboBoxComponent;
  //#endregion

  performMaintenanceFiltered: any = [
    { id: '1', code: 'Perform Maintenance' },
    { id: '2', code: 'Scheduled Maintenance' },
    { id: '3', code: 'Performed Maintenance' },
  ];

  performMaintenance: any = [
    { id: '1', code: 'Perform Maintenance' },
    { id: '2', code: 'Scheduled Maintenance' },
    { id: '3', code: 'Performed Maintenance' },
  ];
  performMaintenanceValue: any;

  disposeAuthorizationStatusFiltered: any = [
    { id: 0, code: 'All' },
    { id: 2, code: 'Approved' },
    { id: 3, code: 'Rejected' }
  ];

  disposeAuthorizationStatus: any = [
    { id: 0, code: 'All' },
    { id: 2, code: 'Approved' },
    { id: 3, code: 'Rejected' }
  ];

  CloseDialogSubscription: any;
  constructor(
    private router: Router,
    private _gridFields: GridFieldsService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutComponent: GridLayoutComponent<T>,
    public _sharedService: SharedService,
    private _securityService: SecurityService,
    private renderer: Renderer2,
    private _gridLayoutManagerServicelocation: GridLayoutManagerService,
    private _assetPurchaseOrdersService: AssetPurchaseOrdersService,
    private _assetCheckOutTransactionsService: AssetCheckOutTransactionsService,
    private _assetCheckInTransactionsService: AssetCheckInTransactionsService,
    private _assetMoveTransactionsService: AssetMoveTransactionsService,
    private _assetDisposeTransactionsService: AssetDisposeTransactionsService,
    private _historySettingsService: HistorySettingsService

  ) {
    super();
    //   this.applesBasket$ = this._gridLayoutManagerService.getAppleBasket();
    this.grideditcolumn = this._gridLayoutManagerService.subscribeToColumnsChanges2();

    /* this._searchControl.valueChanges
      .pipe(debounceTime(700), distinctUntilChanged())
      .subscribe((q) => {
        this.onSearch.emit(q);
        setTimeout(() => {
          this.searchInput.nativeElement.focus();
        }, 500);
      }); */

    //this._isTransactionFire = this._gridLayoutManagerService.sendanybehaviorsubject();
    this.receivebehavior = this._gridLayoutManagerServicelocation.sendanybehaviorsubject()



    this.getLicense();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    }

    this.CloseDialogSubscription = this._sharedService.closeDialog.subscribe(x => {
      if (x.component != "reportViewer")
        this._getGridFieldColumnsUpdated();
    });

  }
  ngOnDestroy(): void {
    if (this.CloseDialogSubscription)
      this.CloseDialogSubscription.unsubscribe();
  }
  doSearch(e: any) {
    this.onSearch.emit(this._searchControl.value);
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 500);
  }

  clearSearch() {
    this._searchControl.setValue('');
    this.onSearch.emit('');
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 100);
  }
  ngOnInit() {
    if (this._assetPurchaseOrderStatusValue) {
      this.assetPurchaseOrdersStatusValue = this.assetPurchaseOrdersStatusFiltered.find((x: any) => x.id == this._assetPurchaseOrderStatusValue);
    }
    if (this._stockPurchaseOrderStatusValue) {
      this.stockPurchaseOrdersStatusValue = this.stockPurchaseOrdersStatusFiltered.find((x: any) => x.id == this._stockPurchaseOrderStatusValue);
    }
    if (this._stockSalesOrderStatusValue) {
      this.stockSalesOrdersStatusValue = this.stockSalesOrdersStatusFiltered.find((x: any) => x.id == this._stockSalesOrderStatusValue);
    }
    if (this._siteTransferStatusValue !== undefined && this._siteTransferStatusValue !== null) {
      this.siteTransfersStatusValue = this.siteTransfersStatusFiltered.find((x: any) => x.id == this._siteTransferStatusValue) || this.siteTransfersStatusFiltered[0];
    } else if (this.page == 'siteTransfers' || this.page == 'site-transfers') {
      this.siteTransfersStatusValue = this.siteTransfersStatusFiltered[0];
    }
    if (this.assetReservationItemTypeValue) {
      this.assetReservationValue = this.assetReservationFiltered.find((x: any) => x.id == this.assetReservationItemTypeValue);
    }
    if (this.disposeAuthorizationStatusValue !== null) {
      const authId = this.disposeAuthorizationStatusValue?.id !== undefined ? this.disposeAuthorizationStatusValue.id : this.disposeAuthorizationStatusValue;
      this.disposeAuthorizationStatusValue = this.disposeAuthorizationStatusFiltered.find((x: any) => x.id == authId) || this.disposeAuthorizationStatusFiltered[0];
    }
    if (this.performMaintenanceItemTypeValue) {
      this.performMaintenanceValue = this.performMaintenanceFiltered.find((x: any) => x.id == this.performMaintenanceItemTypeValue) || this.performMaintenanceFiltered[0];
    } else if (this.page == 'perform-maintenance' || this.overridePage == 'perform-maintenance' || this.isPerformMaintenance) {
      this.performMaintenanceValue = this.performMaintenanceFiltered[0];
    }

    if (this.page == 'history' || this.page == 'asset-all-history' || this.isHistoryPage) {
      if (this._historyFilterValue) {
        const found = this.historyFilterOptions.find((x: any) => x.value === this._historyFilterValue || x.value === this._historyFilterValue?.value);
        if (found) {
          this.historyFilterValue = found;
        }
      } else {
        this._historySettingsService.getHistorySetting().subscribe({
          next: (setting) => {
            if (setting && setting.filterGridBasedOn) {
              const raw = setting.filterGridBasedOn;
              const rawLower = String(raw).trim().toLowerCase();
              let val = 'LastMonth';
              if (raw === 1 || rawLower === 'lastday') val = 'LastDay';
              else if (raw === 2 || rawLower === 'lastmonth') val = 'LastMonth';
              else if (raw === 3 || rawLower === 'lastsixmonths') val = 'LastSixMonths';
              else if (raw === 4 || rawLower === 'all') val = 'All';

              const found = this.historyFilterOptions.find((x: any) => x.value === val);
              if (found) {
                this.historyFilterValue = found;
                this._gridLayoutComponent.GetHistoryFilterValue(found.value, false);
              }
            }
          },
          error: () => {}
        });
      }
    }
    this._getGridColumns();
    this._litItemsByPage();

    if (!this.title) {
      this._gridFields.getPageByName(this.overridePage == '' ? this.page : this.overridePage).subscribe((data) => {
        this.title = data.titleName;
      });
    }

    //     if(this.page == 'asset-purchaseOrders')
    //     {
    // this._assetPurchaseOrdersService.getPurchaseOrderStatusList().subscribe((data: any) =>
    // {
    //   this.assetPurchaseOrdersStatus = data;
    //   this.assetPurchaseOrdersStatusFiltered = data;
    //   if(data && data.length > 0)
    //   this.assetPurchaseOrdersStatusValue = data[0];
    // });

    //     }
    //#endregion
  }
  //#region Asset Purchase Orders Action Methods
  _handleHistoryFilterChange(value: any) {
    setTimeout(() => {
      if (value) {
        this.historyFilterValue = typeof value === 'object' ? value : (this.historyFilterOptions.find(x => x.value === value) || value);
      } else {
        this.historyFilterValue = this.historyFilterOptions[1];
      }
      const filterKey = this.historyFilterValue?.value || this.historyFilterValue;
      this._gridLayoutComponent.GetHistoryFilterValue(filterKey, true);
    }, 100);
  }

  _handlePoStatusFilter(value: any) {
    this.assetPurchaseOrdersStatusFiltered = this.assetPurchaseOrdersStatus.filter(
      (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handlePoStatusChange(value: any) {
    setTimeout(() => {


      if (value) {

        this.assetPurchaseOrdersStatusValue = value

      }

      else {
        if (this.assetPurchaseOrdersStatus && this.assetPurchaseOrdersStatus.length > 0) {
          this.kendoAssetPurchaseOrdersStatus.value = this.assetPurchaseOrdersStatusFiltered[0];
          this.assetPurchaseOrdersStatusValue = this.assetPurchaseOrdersStatus[0];

        }


      }
      this._gridLayoutComponent.GetAssetPurchaseOrderStatusValue(this.assetPurchaseOrdersStatusValue.id);
    }, 100);


  }

  _handleStockPoStatusFilter(value: any) {
    this.stockPurchaseOrdersStatusFiltered = this.stockPurchaseOrdersStatus.filter(
      (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleStockPoStatusChange(value: any) {
    setTimeout(() => {
      if (value) {
        this.stockPurchaseOrdersStatusValue = value;
      } else {
        if (this.stockPurchaseOrdersStatus && this.stockPurchaseOrdersStatus.length > 0) {
          this.kendoStockPurchaseOrdersStatus.value = this.stockPurchaseOrdersStatusFiltered[0];
          this.stockPurchaseOrdersStatusValue = this.stockPurchaseOrdersStatus[0];
        }
      }
      this._gridLayoutComponent.GetStockPurchaseOrderStatusValue(this.stockPurchaseOrdersStatusValue.id);
    }, 100);
  }

  _handleStockSoStatusFilter(value: any) {
    this.stockSalesOrdersStatusFiltered = this.stockSalesOrdersStatus.filter(
      (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleStockSoStatusChange(value: any) {
    setTimeout(() => {
      if (value) {
        this.stockSalesOrdersStatusValue = value;
      } else {
        if (this.stockSalesOrdersStatus && this.stockSalesOrdersStatus.length > 0) {
          this.kendoStockSalesOrdersStatus.value = this.stockSalesOrdersStatusFiltered[0];
          this.stockSalesOrdersStatusValue = this.stockSalesOrdersStatus[0];
        }
      }
      this._gridLayoutComponent.GetStockSalesOrderStatusValue(this.stockSalesOrdersStatusValue.id);
    }, 100);
  }

  _handleSiteTransferStatusFilter(value: any) {
    this.siteTransfersStatusFiltered = this.siteTransfersStatus.filter(
      (s: any) => s.code.toLowerCase().indexOf((value || '').toLowerCase()) !== -1
    );
  }

  _handleSiteTransferStatusChange(value: any) {
    setTimeout(() => {
      if (value !== undefined && value !== null) {
        if (typeof value === 'object') {
          this.siteTransfersStatusValue = value;
        } else {
          this.siteTransfersStatusValue =
            this.siteTransfersStatus.find((x: any) => x.id == value || x.code?.toLowerCase() === value?.toString().toLowerCase()) ||
            { id: value, code: value };
        }
      } else {
        if (this.siteTransfersStatus && this.siteTransfersStatus.length > 0) {
          this.siteTransfersStatusValue = this.siteTransfersStatus[0];
          if (this.kendoSiteTransfersStatus) {
            this.kendoSiteTransfersStatus.value = this.siteTransfersStatusFiltered[0];
          }
        }
      }
      const statusId = this.siteTransfersStatusValue?.id ?? this.siteTransfersStatusValue;
      this._gridLayoutComponent.GetSiteTransferStatusValue(statusId);
    }, 100);
  }

  _handleReservationChange(value: any) {
    setTimeout(() => {
      if (value) {
        this.assetReservationValue = value
      }
      else {
        if (this.assetReservation && this.assetReservation.length > 0) {
          this.kendoAssetReservation.value = this.assetReservationFiltered[0];
          this.assetReservationValue = this.assetReservation[0];
        }
      }
      this.assetReservationItemTypeValue = this.assetReservationValue.id;
      this._gridLayoutComponent.GetAssetReservationValue(this.assetReservationValue.id);
      this._litItemsByPage();
    }, 100);


  }

  _handleReservationFilter(value: any) {
    this.assetReservationFiltered = this.assetReservation.filter(
      (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleDisposeAuthorizationChange(value: any) {
    setTimeout(() => {
      if (value) {
        this.disposeAuthorizationStatusValue = value;
      }
      else {
        if (this.disposeAuthorizationStatus && this.disposeAuthorizationStatus.length > 0) {
          this.kendoDisposeAuthorization.value = this.disposeAuthorizationStatusFiltered[0];
          this.disposeAuthorizationStatusValue = this.disposeAuthorizationStatus[0];
        }
      }
      this._gridLayoutComponent.GetDisposeAuthorizationValue(this.disposeAuthorizationStatusValue);
    }, 100);
  }

  _handleDisposeAuthorizationFilter(value: any) {
    this.disposeAuthorizationStatusFiltered = this.disposeAuthorizationStatus.filter(
      (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handlePerformMaintenanceChange(value: any) {
    setTimeout(() => {
      if (value) {
        this.performMaintenanceValue = value;
      } else {
        if (this.performMaintenance && this.performMaintenance.length > 0) {
          this.kendoPerformMaintenance.value = this.performMaintenanceFiltered[0];
          this.performMaintenanceValue = this.performMaintenance[0];
        }
      }
      this.performMaintenanceItemTypeValue = this.performMaintenanceValue.id;
      this._gridLayoutComponent.GetPerformMaintenanceValue(this.performMaintenanceValue.id);
    }, 100);
  }

  _handlePerformMaintenanceFilter(value: any) {
    this.performMaintenanceFiltered = this.performMaintenance.filter(
      (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }


  getLicense() {
    this._securityService.getLicense().subscribe((x: any) => {
      if (x.stock) {
        this._stockLicense = x.stock;
      } else {
        this._stockLicense = x;
      }
      if (x.asset) {
        this._assetLicense = x.asset;
      } else {
        this._assetLicense = x;
      }

      if (x.general) {
        this._generalLicense = x.general;
      } else {
        this._generalLicense = x;
      }
    });
  }
  showTextbox() {
    this.showTextBox = true;
    //document.getElementById('titleTextBox').focus();
    //this.titleTextBox.nativeElement.focus();
  }

  closeTextbox(event: any) {
    //this.title=event.value;
    this._gridFields.EditPageTitle(this.overridePage == '' ? this.page : this.overridePage, event.value).subscribe((data: any) => {
      this.title = data.titleName;
      this._sharedService.TitleChanged.emit(true);
    });
    this.showTextBox = false;
  }

  _onToggleGraph() {
    this._showGraph = !this._showGraph;
    this._gridLayoutComponent.toggleGraphvisibility(this._showGraph);
  }
  viewinactive: boolean = false
  _onRefresh(deleted: boolean = false, e: any = null) {
    //this.onSearch.emit('');
    this._searchControl.setValue('');


    let result: any;
    this._inActiveMode = deleted;
    this._litItemsByPage();
    if (e == null) {

      this._gridLayoutComponent.GetActiveMode(this._inActiveMode);
      this.refreshButtonClicked.emit('');
    }
    else {

      this._gridLayoutComponent.GetActiveMode(this._inActiveMode);
      this.viewActiveInActiveClicked.emit(this._inActiveMode);
    }
    let modelsubject: any = {
      eventvalue: e,
      isreload: true

    }
    if (e != null) {
      this.receivebehavior.next(modelsubject)
      // this.viewActiveInActiveClicked.emit(deleted);
      // this._gridLayoutComponent.GetActiveMode(deleted);
    }
    // else
    // {
    //   this.refreshButtonClicked.emit('');
    //   this._gridLayoutComponent.GetActiveMode(deleted);

    // }

    // this._gridLayoutComponent.GetActiveMode(this._inActiveMode);

    // this._gridLayoutManagerService.setGridColumnSubjects(this.page, this._gridColumns);

    // if(!this.addNewFormEnabled)
    // {
    let getgridColumns = this._gridColumns.filter((a: any) => a.selected === true)
    this._gridLayoutManagerService.setGridColumnSubjects(this.page, getgridColumns);
    //   .getGridFieldsByPage(this.page)
    //   
    //   .subscribe((data: any) => {
    //     result = data ;
    //     if(this._generalLicense && this._generalLicense.numberOfSites == 1){
    //       this._gridColumns =this._gridColumns.filter(f => !this.SiteFields.includes(f.field));
    //     }
    //     let getgridColumns = this._gridColumns.filter((a:any) => a.selected === true)
    //     this._gridLayoutManagerService.setGridColumnSubjects(this.page, getgridColumns);
    //     this.grideditcolumn.next(getgridColumns)


    //   });
    //}


  }

  _onOpenCloseChange(deleted: boolean = false) {
    this._isClosed = deleted;
    this._gridLayoutComponent.GetClosedMode(this._isClosed);
    this._gridFields
      .getGridFieldsByPage(this.page)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this.page, data);
      });
  }
  _switchState() {
    this._gridLayoutComponent.GetActiveMode(!this._inActiveMode);
  }

  _itemDisabled(itemArgs: { dataItem: any; index: number }): boolean {
    return itemArgs.dataItem.$disabled;
  }

  editgridcolum() {
    if (this._generalLicense && this._generalLicense.numberOfSites == 1) {
      //this._gridColumns =this._gridColumns.filter(f => f.field != 'site.code' && f.field != 'site.id' && f.field != 'site.name' && f.field != 'site.description' );
      this._gridColumns = this._gridColumns.filter(f => !this.SiteFields.includes(f.field));
    }
    this.grideditcolumn.next(this._gridColumns)
  }
  changeApples() {
    this.applesBasket$.next(this._searchControl.value);
  }

  _gridFieldsSelected(e: any) {
    if (e.length > this.maxColumns) {
      this._layoutComponent.openPopup({
        title: 'Alert',
        message: 'The maximum allowed columns is ' + this.maxColumns + '.',
        returnAfterOkCloseClick: true,
        withoutConfirm: true
      });
      this._gridLayoutManagerService.setGridColumnSubjects(this.page, this._gridColumns);
      return;
    }
    this._gridColumns.forEach((column: any) => {
      column.selected = e.find((x: any) => x.id == column.id) != null;
    });

    let model = {
      gridFieldIds: e.map((x: any) => x.id),
      page: this.page,
    };
    this._gridFields
      .updateGridField(model)

      .subscribe((data: any) => {
        let getgridColumns = this._gridColumns.filter((a: any) => a.selected === true)
        this._gridLayoutManagerService.setGridColumnSubjects(this.page, getgridColumns);
        this.grideditcolumn.next(getgridColumns)

      });


    if (e.length === 1) {
      (this._gridColumns.find(x => x.selected) as any).$disabled = true;
    } else {
      this._gridColumns.forEach((column: any) => {
        (column as any).$disabled = false;
      });
    }

    this._gridLayoutComponent.fitColumns(e.length + 1);
    this._editColumnsActive = false;
    this.SendEditColumnsValueToGridLayoutService();
  }

  _addNew() {

    this.openUpsert(this.overridePage || this.page, {}, PageState.ADD, true);
  }

  _toggleGrouping() {
    this._groupingEnabled = !this._groupingEnabled;
    this._gridLayoutComponent.toggleGrouping(this._groupingEnabled);
  }

  _onImport() {
    // if (this.assetsModules.find(a => a === this.page)){
    //   if(this.page != 'departments')
    //   this.router.navigate(['asset/import'], { queryParams: { file: this.page } });
    //   else
    //   this.router.navigate(['stock/import'], { queryParams: { file: this.page } });
    // }
    // else {
    //   this.router.navigate(['stock/import'], { queryParams: { file: this.page } });
    // }

    this.router.navigate([this._sharedService.base + '/import'], { queryParams: { file: this.page } });

  }

  _onExportExcelExportPdf(exportpdft: boolean = false) {
    this._gridLayoutComponent.exportToExcel(exportpdft);
  }

  _onExportPDF() {
    if (this._groupingEnabled) {
      this._groupingEnabled = !this._groupingEnabled;
      this._gridLayoutComponent.toggleGrouping(this._groupingEnabled);
    }

    setTimeout(() => {
      this._gridLayoutComponent.exportToPDF();
    }, 1000);

  }

  _onExportCSV() {
    this._gridLayoutComponent.exportToCsv();
  }

  _onExportWord() {
    this._gridLayoutComponent.exportToWord();
  }

  _getGridColumns() {

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges(this.page, (gridColumns) => {

      if (gridColumns && gridColumns.length) {

        this._gridColumns = gridColumns.filter((x) => x.field !== null);
        this._selectedColumns = gridColumns.filter((x) => x.selected);

        if (this._selectedColumns.length == 1) {
          (this._gridColumns.find(x => x.selected) as any).$disabled = true;
        }
        if (this._generalLicense && this._generalLicense.numberOfSites == 1) {
          this._gridColumns = this._gridColumns.filter(f => f.field != 'site.code' && f.field != 'site.id' && f.field != 'site.name' && f.field != 'site.description');
        }
        this._groupedData = this.groupColumnsByName(this._gridColumns);
      }
    }));
  }

  _getGridFieldColumnsUpdated() {
    this._gridFields
      .getGridFieldsByPage(this.page)

      .subscribe((data: any) => {
        if (this._generalLicense && this._generalLicense.numberOfSites == 1) {
          //this._gridColumns =this._gridColumns.filter(f => f.field != 'site.code' && f.field != 'site.id' && f.field != 'site.name' && f.field != 'site.description' );
          data = data.filter((f: any) => !this.SiteFields.includes(f.field));
        }
        this._gridLayoutManagerService.setGridColumnSubjects(this.page, data);

      });

    //this.SendEditColumnsValueToGridLayoutService();
  }

  openUpsert(componentName: string, model: any, pageState: PageState, isfromlist: any = false) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState, isNew: true, openfromlist: isfromlist };
  }

  _closeDialog(event: any) {
    if (typeof event === 'boolean') {
      this._isDialiog = event;
    } else if (event && typeof event.open === 'boolean') {
      this._isDialiog = event.open;
    } else if (event && event.isClosed) {
      this._isDialiog = false;
    } else {
      this._isDialiog = false;
    }
  }

  ngOnChanges() {
    if (this.performMaintenanceItemTypeValue) {
      this.performMaintenanceValue = this.performMaintenanceFiltered.find((x: any) => x.id == this.performMaintenanceItemTypeValue) || this.performMaintenanceFiltered[0];
    }
    this._litItemsByPage();
  }

  _litItemsByPage() {

    this.receivebehavior.subscribe(value => {
      this.viewinactive = value ?? false
    })
    if (this.page === 'stockItems')
      this.listItems = ['Deactivate', 'Receive', 'Issue'];
    else if (this.page == 'inventories')
      this.listItems = ['Move', 'Receive', 'Dispose', 'Issue'];
    else if (this.page == 'asset-inventory')
      this.listItems = ['Move', 'Check Out', 'Check In', 'Dispose', 'Deactivate'];
    else if (this.page == 'stockDisposeAuthorizationTransaction')
      this.listItems = ['Approve', 'Reject'];
    else if (this.page == 'stockAdjustAuthorizationTransaction')
      this.listItems = ['Approve', 'Reject'];
    else if (this.page == 'assetdispose-authorization')
      this.listItems = ['Approve', 'Reject'];
    else if (this.page == 'assetadjust-authorization')
      this.listItems = ['Approve', 'Reject'];
    else if (this.page == 'stockdispose-authorization-history' || this.page == 'stockadjust-authorization-history')
      this.listItems = [];
    else if (this.page == 'assetdispose-authorization-history' || this.page == 'assetadjust-authorization-history')
      this.listItems = [];
    else if (this.page == 'asset-purchaseOrders' || this.page == 'purchaseOrders')
      this.listItems = [];
    else if (this.page == 'asset-reservation' || this.page == 'asset-reservation-list')
      this.listItems = ['Deactivate'];
    else if (this.isAssetReservation && this.page == 'assets' && this.assetReservationItemTypeValue == 2)
      this.listItems = ['Reserve', 'Deactivate'];
    else if (this.isAssetReservation && this.page == 'assets')
      this.listItems = ['Deactivate'];
    else if (this.page == 'pickList')
      this.listItems = this._isClosed ? ['Reactivate'] : ['Close'];
    else if (this.page == 'siteTransfers' || this.page == 'site-transfers')
      this.listItems = ['Deactivate'];
    else
      this.listItems = ['Deactivate'];

    if (!this.canDeactivate)
      this.listItems = this.listItems.filter(a => a != 'Deactivate');

    if (!this.canReceive)
      this.listItems = this.listItems.filter(a => a != 'Receive');

    if (!this.canMove)
      this.listItems = this.listItems.filter(a => a != 'Move');
    if (!this.canDispose)
      this.listItems = this.listItems.filter(a => a != 'Dispose');
    if (!this.canIssue)
      this.listItems = this.listItems.filter(a => a != 'Issue');
    if (!this.canApprove)
      this.listItems = this.listItems.filter(a => a != 'Approve');
    if (!this.canReject)
      this.listItems = this.listItems.filter(a => a != 'Reject');
    if (!this.canCheckOut)
      this.listItems = this.listItems.filter(a => a != 'Check Out');
    if (!this.canCheckIn)
      this.listItems = this.listItems.filter(a => a != 'Check In');

    // if(this.canReactivate && this._inActiveMode == true)
    // {
    //   this.listItems = ['Reactivate'];
    // }
    if (this._inActiveMode) {
      this.listItems = ['Reactivate'];
    }
    // if(this.viewinactive && this.canActivate)
    // this.listItems = ['Reactivate'];


  }

  isBatchAction: boolean = false;
  _batchAction(event: any) {
    if (this.selectedItems.length == 0) {
      this._layoutComponent.openPopup({
        title: 'Error',
        message: 'No items were selected',
        withoutConfirm: true
      });
      return;
    }

    const isAssetPage = this.page && (this.assetsModules.includes(this.page) || this.page.startsWith('asset'));

    if ((event === 'Deactivate' || event === 'Reactivate' || event === 'Activate') && this.page != 'stockdispose-authorization-history' && this.page != 'stockadjust-authorization-history') {
      if (event === 'Reactivate') {
        if (this.page == "users") {
          this._layoutComponent.openPopup({
            title: 'Notification',
            message: 'Are you sure you want to reactivate these users ' + '?' + '<br/>' + 'If yes, The users' +
              ' will be moved to activated data.'
          });
        }
        else {
          this._layoutComponent.openPopup({
            title: 'Notification',
            message: 'Are you sure you want to reactivate these items ' + '?' + '<br/>' + 'If yes, The items' +
              ' will be moved to activated data.'
          });
        }

      }
      else {
        this.isBatchAction = true;
        if (this.page == "users") {
          this._layoutComponent.openPopup({
            title: 'Notification',
            message: 'Are you sure you want to deactivate these users ' + '?' + '<br/>' + 'If yes, The users' +
              ' will be moved to deactivated data.'
          });
        }
        else {
          this._layoutComponent.openPopup({
            title: 'Notification',
            message: 'Are you sure you want to deactivate these items ' + '?' + '<br/>' + 'If yes, The items' +
              ' will be moved to deactivated data.'
          });
        }
      }


      if (this.okCloseSubscription) {
        this.okCloseSubscription.unsubscribe();
        this.okCloseSubscription = null;
      }
      this.okCloseSubscription = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
        if (this.okCloseSubscription) {
          this.okCloseSubscription.unsubscribe();
          this.okCloseSubscription = null;
          if (data) {
            if (this.page == 'users' && this.selectedItems && !this._currentUser.isEnterprise && false) {
              this.okCloseSubscription = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
                if (data) {
                  this._layoutComponent.openDialogForm(formComponentMapOptions['assigned-assets'], null, { batch: this.selectedItems, pageName: this.page });
                }
              });
              this._layoutComponent.openPopup({
                title: 'Notification',
                message: 'Some of the selected users have assets assigned to them. <br/> Would you like to proceed with the deactivation?'
              });
            } else {
              if (event === 'Reactivate') {
                this._layoutComponent.openDialogForm(formComponentMapOptions['reactivate-data'], PageState.VIEW, { batch: this.selectedItems, Batchstatus: EntityStatus.Active, pageName: this.page });
              }
              else {

                this._layoutComponent.openDialogForm(formComponentMapOptions['deactivate-data'], PageState.VIEW, { batch: this.selectedItems, Batchstatus: EntityStatus.Deleted, pageName: this.page });
              }
            }
          } else {

            if (this.okCloseSubscription) {
              this.okCloseSubscription.unsubscribe();
              this.okCloseSubscription = null;
            }
          }
        }
      });
    }

    if (event == 'Reserve') {

      let modelData: IAssetReservationDto = {} as IAssetReservationDto;
      let modelDataDetails: IAssetReservationDetailsDto[] = [];

      this.selectedItems.forEach((item: IAssetDto, idx: number) => {
        const modelDataDetail: IAssetReservationDetailsDto = {} as IAssetReservationDetailsDto;
        modelDataDetail.id = 0;
        modelDataDetail.index = idx + 1;
        modelDataDetail.assetId = item.id;
        modelDataDetail.assetNumber = item.assetNumber;
        modelDataDetail.assetName = item.assetName;
        modelDataDetail.asset = item;
        modelDataDetail.locationCode = item.location?.code;
        modelDataDetail.assetReservationId = 0;
        modelDataDetail.isCheckedOut = false;

        modelDataDetails.push(modelDataDetail);
      });

      modelData.reservationNumber = '';
      modelData.toBeCheckedOutDate = new Date();
      modelData.toBeCheckedInDate = new Date();
      modelData.assetReservationDetails = modelDataDetails;
      modelData.reservationMadeDate = new Date();

      this._layoutComponent.openUpsert('asset-reservation', modelData, PageState.ADD);

    }
    else if (event === 'Receive') {
      if (this.selectedItems) {
        if (isAssetPage) {
          this._sharedService.batchStocks = { stockItems: this.selectedItems };
          this.router.navigate(['asset/transactions/receive']);
        } else {
          this._sharedService.batchStocks = { stockItems: this.selectedItems };
          this.router.navigate(['stock/transaction/receive']);
        }
      }
    }
    else if (event === 'Move') {
      if (this.selectedItems) {
        if (isAssetPage) {
          this._sharedService.batchStocks = { stockItems: this.selectedItems };
          this._assetMoveTransactionsService.FromInventory = [...this.selectedItems];
          this.router.navigate(['asset/transactions/move']);
        } else {
          this._sharedService.batchInventories = { moveInventories: this.selectedItems };
          this.router.navigate(['stock/transaction/move']);
        }
      }
    }
    else if (event === 'Check Out') {
      if (this.selectedItems && isAssetPage) {
        this._sharedService.batchStocks = { stockItems: this.selectedItems };
        this._assetCheckOutTransactionsService.FromInventory = [...this.selectedItems];
        this.router.navigate(['asset/transactions/checkout']);
      }
    }
    else if (event === 'Check In') {
      if (this.selectedItems && isAssetPage) {
        this._sharedService.batchStocks = { stockItems: this.selectedItems };
        this._assetCheckInTransactionsService.FromInventory = [...this.selectedItems];
        this.router.navigate(['asset/transactions/checkin']);
      }
    }
    else if (event === 'Dispose') {
      if (this.selectedItems) {
        if (isAssetPage) {
          this._sharedService.batchStocks = { stockItems: this.selectedItems };
          this._assetDisposeTransactionsService.FromInventory = [...this.selectedItems];
          this.router.navigate(['asset/transactions/dispose']);
        } else {
          this._sharedService.batchInventories = { disposeInventories: this.selectedItems };
          this.router.navigate(['stock/transaction/dispose']);
        }
      }
    }
    else if (event === 'Issue') {
      if (this.selectedItems) {
        this._sharedService.batchInventories = { issueInventories: this.selectedItems };
        this.router.navigate(['stock/transaction/issue']);
      }
    }
    else if (event === 'Approve' && (this.page == 'stockdispose-authorization-history' || this.page == 'stockadjust-authorization-history' || this.page == 'stockDisposeAuthorizationTransaction' || this.page == 'stockAdjustAuthorizationTransaction' || this.page == 'assetdispose-authorization-history' || this.page == 'assetadjust-authorization-history'|| this.page == 'assetAdjustAuthorizationTransaction' || this.page == 'assetdispose-authorization' || this.page == 'assetadjust-authorization')) {
      this.batchActionClicked.emit('Approve');
    }
    else if (event === 'Reject' && (this.page == 'stockdispose-authorization-history' || this.page == 'stockadjust-authorization-history' || this.page == 'stockDisposeAuthorizationTransaction' || this.page == 'stockAdjustAuthorizationTransaction' || this.page == 'assetdispose-authorization-history' || this.page == 'assetadjust-authorization-history'|| this.page == 'assetAdjustAuthorizationTransaction' || this.page == 'assetdispose-authorization' || this.page == 'assetadjust-authorization')) {
      this.batchActionClicked.emit('Reject');
    }
    else if (event === 'Deactivate' && (this.page == 'stockdispose-authorization-history' || this.page == 'stockadjust-authorization-history' || this.page == 'stockDisposeAuthorizationTransaction' || this.page == 'stockAdjustAuthorizationTransaction' || this.page == 'assetdispose-authorization-history' || this.page == 'assetadjust-authorization-history' || this.page == 'assetAdjustAuthorizationTransaction' || this.page == 'assetdispose-authorization' || this.page == 'assetadjust-authorization')) {
      this.batchActionClicked.emit('Deactivate');
    }
    else if ((event === 'Close' || event === 'Open' || event === 'Reactivate') && this.page == 'pickList') {
      this.batchActionClicked.emit(event);
    }
    this.kendoBatchActions.reset();
  }

  SendEditColumnsValueToGridLayoutService() {
    this._gridLayoutManagerService.Set_editColumnsActive(this._editColumnsActive);
  }

  private groupColumnsByName(columns: any[]): any[] {
    const groupMap = new Map();

    columns.forEach(column => {
      const groupId = column.columnsGroup?.id ?? ('col_' + column.id);
      const groupName = column.columnsGroup?.name ?? (column.gridFieldText?.currentText ?? column.title);
      const groupOrder = column.columnsGroup?.order == 0 ? Number.MAX_SAFE_INTEGER : column.columnsGroup?.order;

      if (!groupMap.has(groupId)) {
        groupMap.set(groupId, {
          key: groupId,
          id: groupId,
          name: groupName,
          value: groupName,
          order: groupOrder,
          items: []
        });
      }

      groupMap.get(groupId).items.push(column);
    });

    const sortedGroups = Array.from(groupMap.values())
      .sort((a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER));

    sortedGroups.forEach(group => {
      group.items.sort((a: any, b: any) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER));
    });

    return sortedGroups;
  }
}
